import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Doughnut } from 'react-chartjs-2';
import intlShape from '@/shared/utils/intlShape';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { Chart, Legend, LinearScale, Tooltip, CategoryScale, ArcElement } from 'chart.js';
import { NoDecimalsTooltipLabel } from '@/shared/utils/chartjsHelpers';
import { injectStateService, StateService } from '@/shared/services/StateService';
import messages from '../dashboardMessages';

Chart.register(Legend, LinearScale, Tooltip, CategoryScale, ArcElement);

const PeppolInvoicingByCustomersChart = ({ intl, stateService, companyId, data: rawData }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const {
      sendInvoicePeppolReady,
      sendInvoicePeppolNotReady,
      sendInvoicePeppolUnknown,
      sendInvoicePeppolNotApplicable,
    } = rawData;
    if (
      sendInvoicePeppolReady >= 0 ||
      sendInvoicePeppolNotReady >= 0 ||
      sendInvoicePeppolUnknown >= 0 ||
      sendInvoicePeppolNotApplicable >= 0
    ) {
      setChartData({
        labels: [
          intl.formatMessage(messages.NotReady),
          intl.formatMessage(messages.Ready),
          intl.formatMessage(messages.Unknown),
          intl.formatMessage(messages.NotApplicable),
        ],
        datasets: [
          {
            data: [
              sendInvoicePeppolNotReady,
              sendInvoicePeppolReady,
              sendInvoicePeppolUnknown,
              sendInvoicePeppolNotApplicable,
            ],
            backgroundColor: ['#B80016', '#00B295', '#F0A800', '#797390'],
            borderColor: '#ffffff',
            hoverBorderColor: '#ffffff',
            borderWidth: 0.5,
          },
        ],
      });
    }
  }, [rawData, intl]);

  const chartOptions = {
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: 'right',
        align: 'left',
      },
      tooltip: {
        enabled: true,
        mode: 'index',
        displayColors: false,
        callbacks: {
          label: context => {
            return NoDecimalsTooltipLabel(
              context,
              intl.formatMessage(messages.Customers).toLowerCase(),
            );
          },
        },
      },
    },
    events: ['click', 'mousemove'], // this is needed, otherwise onHover is not fired
    onHover: (event, chartElement) => {
      // eslint-disable-next-line no-param-reassign
      event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    onClick: (event, chartElements) => {
      const [element] = chartElements || [];
      if (!element) return;
      const peppolReadyStatus = [1, 2, 4, 3][element.index];

      stateService.gotoRelationOverview({
        isPeppolRequired: true,
        sendInvoicePeppolReady: [peppolReadyStatus],
        ownCompanies: [companyId],
      });
    },
  };

  return !chartData ? null : <Doughnut data={chartData} options={chartOptions} />;
};

PeppolInvoicingByCustomersChart.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.shape({}).isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
};

export default injectStateService(injectIntl(PeppolInvoicingByCustomersChart));
